<template>
  <datepicker
    :language="languages[language]"
    style="z-index:99999999"
    v-model="model"
    :format="formatarData"
    :name="name"
    :disabled="disabled"
    :initial-view="initialView"
    @input="$emit('input', model)"
  />
</template>

<script>
import * as lang from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "datepicker-input",
  components: { Datepicker },
  props: {
    value: { type: Date, default: null },
    name: { type: String, default: null },
    initialView: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },
  data: () => {
    return {
      language: "ptBR",
      languages: lang,
      model: null
    };
  },
  created() {
    this.model = this.value;
  },
  watch: {
    value(value) {
      this.model = value;
    }
  },
  methods: {
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY");
    }
  }
};
</script>
